import React, { Component, Fragment } from 'react';
import styles from './JsonForm.module.css';
import Checkbox from 'rc-checkbox';

export default class JsonForm extends Component {
  state = {
    options: [],
    disabled: true,
  };

  addOptions = () => {
    const { options } = this.state;
    options.push({ label: '', value: '' });
    this.setState({ options });
  };

  onChange = (ev, type, key) => {
    const value = ev.target.value;
    const { options } = this.state;
    const { onChange } = this.props;
    options[key][type] = value;
    this.setState({ options });
    onChange(options);
  };

  onToggle = () => {
    const { options, disabled } = this.state;
    if (disabled) {
      options.push({ label: '', value: '' });
      this.setState({ options, disabled: !disabled });
    } else {
      const options = [];
      this.setState({ options, disabled: !disabled });
    }
  };

  componentWillReceiveProps(newProps) {
    const { metadata } = newProps;
    if (metadata !== this.state.metadata) {
      const options = Object.keys(metadata).map(key => ({
        label: key,
        value: metadata[key],
      }));
      this.setState({
        options,
      });
    }
  }

  render() {
    const { options, disabled } = this.state;
    return (
      <Fragment>
        <div className={styles.headerContainer}>
          <label>
            <Checkbox onChange={e => this.onToggle()} /> &nbsp; Add additional
            fields
          </label>
        </div>
        {!disabled &&
          options.map((key, idx) => (
            <div className={styles.optionContainer} key={idx}>
              <div className={styles.labelContainer}>
                <label className={styles.keyLabel}>Label </label>
                <input
                  defaultValue={key.label}
                  className={styles.keyInput}
                  onBlur={e => this.onChange(e, 'label', idx)}
                />
              </div>
              <div className={styles.valueContainer}>
                <label className={styles.keyLabel}>Value </label>
                <input
                  defaultValue={key.value}
                  className={styles.keyInput}
                  onBlur={e => this.onChange(e, 'value', idx)}
                />
              </div>
              {idx === 0 && (
                <a onClick={this.addOptions} className={styles.plusButton}>
                  <img src="/img/plus.png" width="35px" height="35px" />
                </a>
              )}
            </div>
          ))}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JsonForm/index.js